<template>
  <DxPieChart
    id="pie"
    :data-source="statistics"
    palette="Bright"
    :title="title"
    resolve-label-overlapping="shift"
    @point-click="pointClickHandler($event)"
    @legend-click="legendClickHandler($event)"
  >
    <DxSeries
      argument-field="Name"
      value-field="Value"
    >
      <DxLabel :visible="true">
        <DxConnector
          :visible="true"
          :width="1"
        />
      </DxLabel>
    </DxSeries>
    <DxSize :width="500"/>
    <DxExport :enabled="true"/>
  </DxPieChart>
</template>

<script>

import DxPieChart, {
  DxSize,
  DxSeries,
  DxLabel,
  DxConnector,
  DxExport,
} from 'devextreme-vue/pie-chart';

export default {
    props: {
        title: {
            type: String,
            required: true
        },
        statistics: {
            type: Array,
            required: true 
        }
    },
    components: {
        DxPieChart,
        DxSize,
        DxSeries,
        DxLabel,
        DxConnector,
        DxExport,
    },
    data() {
        return {
        };
    },
    methods: {
        pointClickHandler(e) {
        this.toggleVisibility(e.target);
        },
        legendClickHandler(e) {
        const arg = e.target;
        const item = e.component.getAllSeries()[0].getPointsByArg(arg)[0];

        this.toggleVisibility(item);
        },
        toggleVisibility(item) {
        item.isVisible() ? item.hide() : item.show();
        },
    },
    };
</script>

<style>
#pie {
  height: 440px;
}

#pie * {
  margin: 0 auto;
}
</style>
